export function sumBy<T>(fn: (value: T) => number, collection: T[]): number;
export function sumBy<T>(fn: (value: T) => number): (collection: T[]) => number;
export function sumBy<T>(fn: (v: T) => number, collection?: T[]) {
    if (collection) {
        return collection.reduce((acc, value) => acc + fn(value), 0);
    }
    return (arr: T[]) => sumBy(fn, arr);
}
